import Breadcrumb from "../../components/Breadcrumb";
import {
  MBBS_TUITION_FEE_ACADEMIC_YEARS,
  MBBS_TUITION_FEE_NOTES,
  MBBS_TUITION_FEE_STRUCTURE,
} from "../../data/mbbsTuitionFee";
import "./MBBSCourse.css";


const MBBSCourse = () => {
  return (
    <>
      <Breadcrumb title={"MBBS Course"} />

      <section className="mbbs-course py-120">
        <div className="container">
          <div className="mbbs-course__hero">
            <p className="mbbs-course__eyebrow">Courses</p>
            <h2>Bachelor of Medicine and Bachelor of Surgery (MBBS)</h2>
            <p className="mbbs-course__intro">
              The MBBS program builds strong scientific foundations and clinical
              decision-making through progressive bedside exposure. Students are
              trained to deliver ethical, evidence-based care in primary,
              secondary, and tertiary healthcare settings.
            </p>
          </div>





          <section className="mbbs-course__fees">
            <div className="mbbs-course__fees-header">
              <h3>MBBS Tuition Fee Structure</h3>
              <p>
                Source: Academics {">"} Fee Structure {">"} Tuition Fee
              </p>
              <span>
                Applicable for Academic Years: {MBBS_TUITION_FEE_ACADEMIC_YEARS}
              </span>
            </div>

            <div className="table-responsive">
              <table className="mbbs-course__fees-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Fee (Per Annum)</th>
                  </tr>
                </thead>
                <tbody>
                  {MBBS_TUITION_FEE_STRUCTURE.map((fee) => (
                    <tr key={fee.category}>
                      <td>{fee.category}</td>
                      <td>{fee.feePerAnnum}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <ul className="mbbs-course__fee-notes">
              {MBBS_TUITION_FEE_NOTES.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          </section>
        </div>
      </section>
    </>
  );
};

export default MBBSCourse;
